/**
 * PagesList - List view of custom pages
 */
import { Plus, Edit, Trash2, Eye, EyeOff, ExternalLink, FileText } from "lucide-react";
import { Button } from "../../ui/button";

export const PagesList = ({ pages, onEdit, onDelete, onCreateNew }) => {
  if (pages.length === 0) {
    return (
      <div className="bg-zinc-900/50 border border-white/10 p-12 text-center">
        <FileText className="w-16 h-16 text-zinc-700 mx-auto mb-4" />
        <h3 className="text-white font-bold mb-2">No Custom Pages</h3>
        <p className="text-zinc-500 mb-6">
          Create custom pages like About, Sponsors, Rules, etc.
        </p>
        <Button
          onClick={onCreateNew}
          className="bg-zinc-800 text-white hover:bg-zinc-700"
        >
          <Plus className="w-4 h-4 mr-2" />
          Create Your First Page
        </Button>
      </div>
    );
  }

  return (
    <div className="bg-zinc-900/50 border border-white/10 overflow-hidden">
      <table className="w-full">
        <thead>
          <tr className="border-b border-white/10">
            <th className="text-left text-xs font-bold uppercase text-zinc-400 px-4 py-3">Page</th>
            <th className="text-left text-xs font-bold uppercase text-zinc-400 px-4 py-3">URL</th>
            <th className="text-center text-xs font-bold uppercase text-zinc-400 px-4 py-3">Status</th>
            <th className="text-center text-xs font-bold uppercase text-zinc-400 px-4 py-3">Menu</th>
            <th className="text-right text-xs font-bold uppercase text-zinc-400 px-4 py-3">Actions</th>
          </tr>
        </thead>
        <tbody>
          {pages.map((page) => (
            <tr key={page.id} className="border-b border-white/5 hover:bg-white/5">
              <td className="px-4 py-3">
                <div className="text-white font-medium">{page.title}</div>
                <div className="text-xs text-zinc-500">{page.content_blocks?.length || 0} blocks</div>
              </td>
              <td className="px-4 py-3">
                <span className="text-zinc-400 text-sm">/{page.slug}</span>
              </td>
              <td className="px-4 py-3 text-center">
                <span className={`inline-flex items-center gap-1 px-2 py-1 text-xs font-bold uppercase ${
                  page.is_published ? "bg-green-500/20 text-green-500" : "bg-zinc-500/20 text-zinc-400"
                }`}>
                  {page.is_published ? <Eye className="w-3 h-3" /> : <EyeOff className="w-3 h-3" />}
                  {page.is_published ? "Live" : "Draft"}
                </span>
              </td>
              <td className="px-4 py-3 text-center">
                {page.show_in_menu && <span className="text-xs text-zinc-400">In Menu</span>}
              </td>
              <td className="px-4 py-3 text-right">
                <div className="flex items-center justify-end gap-1">
                  {page.is_published && (
                    <a
                      href={`/${page.slug}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="p-2 text-zinc-500 hover:text-white"
                    >
                      <ExternalLink className="w-4 h-4" />
                    </a>
                  )}
                  <button onClick={() => onEdit(page)} className="p-2 text-zinc-500 hover:text-white">
                    <Edit className="w-4 h-4" />
                  </button>
                  <button onClick={() => onDelete(page.id)} className="p-2 text-zinc-500 hover:text-red-500">
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PagesList;
